import HttpService from '../../../ui-home/src/misc/HttpService/HttpService';
import getGatewayApiUrl from './getGatewayApiUrl';

const getDataFromAPI = (query) => HttpService.post(getGatewayApiUrl(), query).then((r) => r.logs);

export default getDataFromAPI;
